<template>
    <Head title="Log in" />

    <div v-if="status" class="mb-4 font-medium text-sm text-green-600">
        {{ status }}
    </div>

    <form @submit.prevent="submit">

        <img :src="urlQr" @click="updateQr" alt="2fa qr-code" class="mx-auto">

        <div class="mt-4">
            <Label for="2FA" value="2FA code" />
            <Input id="2FA" type="text" class="mt-1 block w-full" v-model="form.secret" />
            <InputError :message="form.errors.secret"/>
        </div>

        <div class="flex items-center justify-end mt-4">

            <ButtonSecondary class="ml-4" type="button" :href="route('logout')"  method="post" as="button">
                Cancel
            </ButtonSecondary>

            <Button class="ml-4" type="submit" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                Confirm
            </Button>
        </div>
    </form>
</template>

<script>
import Button from '@/Components/Button.vue';
import ButtonSecondary from '@/Components/ButtonSecondary';
import GuestLayout from '@/Layouts/Guest.vue';
import Input from '@/Components/Input.vue';
import InputError from "@/Components/InputError";
import Label from '@/Components/Label.vue';
import { Head, Link } from '@inertiajs/inertia-vue3';

export default {
    layout: GuestLayout,

    components: {
        Button,
        ButtonSecondary,
        Input,
        InputError,
        Label,
        Head,
        Link,
    },

    props: {
        canResetPassword: Boolean,
        status: String,
    },

    data() {
        return {
            form: this.$inertia.form({
                secret: '',
            }),
            urlQr: route('2fa.generate'),
        }
    },

    methods: {
        submit() {
            this.form.put(this.route('2fa.login'), {
                onFinish: () => this.form.reset('password'),
            })
        },
        updateQr() {
            this.urlQr = `${route('2fa.generate')}?${this.uuid()}`
        }
    }
}
</script>
